import { Directive, HostListener, Renderer2, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { HelperService } from '../services/helper.service';
import Lottie, { AnimationItem } from 'lottie-web';
import { AgTrackingService } from '@ag/vc.ag-core/tracking';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let Microsoft: any;
@Directive({
  selector: '[appHelpWidget]'
})
export class HelpWidgetDirective {
  buttonAnimation: AnimationItem;
  @Input() isBrokerFlow: boolean;
  @Output() widgetOpen = new EventEmitter<boolean>();
  @Output() chatMinimized = new EventEmitter<boolean>();
  @Output() chatSDKReady = new EventEmitter<boolean>();
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private helperService: HelperService,
    private readonly trackingService: AgTrackingService
  ) {
    setTimeout(() => {
      const svgContainer = document.getElementById('widgetbtn_json');
      if (svgContainer){
        this.buttonAnimation = Lottie.loadAnimation(this.helperService.getLottieConfig(svgContainer, false, true, `widgetbtn`, './assets/widget-open-close.json', [0, 60]));
      }
    }, 1000);
  }

  backdrop = this.renderer.createElement('div') as HTMLElement;
  bodyElem: HTMLElement;

  @HostListener('click')
  onClick(): void {
    this.bodyElem = (this.elementRef.nativeElement as HTMLElement).closest('body');
    if (!(this.elementRef.nativeElement as HTMLElement).classList.contains('widget-open')){

      this.renderer.addClass(this.elementRef.nativeElement, 'widget-open'); // adding the class to widget button to know the widget is open
      this.renderer.addClass(this.backdrop, 'widget-backdrop');
      if (this.isBrokerFlow){
        this.renderer.addClass(this.backdrop, 'widget-backdrop-broker');
      }
      this.renderer.appendChild(this.bodyElem, this.backdrop); // adding the backdrop for widget
      setTimeout(() => {
        this.renderer.addClass(this.bodyElem, 'widget-shown');
      }, 100);
      this.backdrop.addEventListener('click', () => {
        this.closeWidget(); // widget closes if user clicks outside the widget
      });
      setTimeout(() => {
        this.buttonAnimation.playSegments([60, 96], true);
      }, 300);
      this.widgetOpen.emit(true);
      this.trackingService.log("button-click", {"name": "chat widget"});
    }else{
      this.closeWidget(); // to close the widget if user clicks on the widget button and it was already open
    }
  }

  closeWidget(): void{
    this.renderer.removeClass(this.elementRef.nativeElement, 'widget-open');
    this.renderer.addClass(this.backdrop, 'removing');
    setTimeout(() => {
      this.renderer.removeClass(this.backdrop, 'removing');
      this.renderer.removeChild(this.bodyElem, this.backdrop);
      this.renderer.removeClass(this.bodyElem, 'widget-shown');
      this.buttonAnimation.playSegments([0, 47], true);
    }, 200);
    this.widgetOpen.emit(false);
  }

  @HostListener('window:lcw:ready', ['$event'])
  onSDKReady(_event: CustomEvent): void {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      Microsoft.Omnichannel.LiveChatWidget.SDK.setContextProvider(function contextProvider(){
        const SelfService= [];
        // Add new link navigations to SelfService
        const title = document.title;
        const navigation = {
            "msdyn_displaytitle": title,
            "msdyn_url": window.location.href,
            "msdyn_starttime": new Date().toISOString(),
            "msdyn_type": "192350000" // Type used for page navigation
        }
        SelfService.unshift(navigation);
        return {
            'SelfService': { 'value': JSON.stringify(SelfService) }
        };
    });
    } catch (exception) {
      console.log('An error occurred in LiveChatWidget: ', exception);
      return null;
    }
    this.chatSDKReady.emit(true);
  }

  @HostListener('window:lcw:onMinimize', ['$event'])
  onChatMinimize(_event: CustomEvent): void {
    this.chatMinimized.emit(true);
  }
  @HostListener('window:lcw:onMaximize', ['$event'])
  onChatMaximize(_event: CustomEvent): void {
    this.chatMinimized.emit(false);
  }
  @HostListener('window:lcw:onClose', ['$event'])
  onChatClose(_event: CustomEvent): void {
    this.chatMinimized.emit(false);
  }
}
